import Swiper from 'swiper';

export class EventsCalendar {
  $eventsList;
  $eventsListDesktop;
  $eventsSlider;
  slider;
  mobile = false;
  firstChangeMobile = false;
  firstChangeDesktop = false;
  hasMobileSlider = false;

  constructor() {}

  initEvents() {
    this.$eventsList = $('.events-list');
    this.$eventsListDesktop = $('.events-list-desktop');
    this.$eventsSlider = $('.events-slider');

    if (this.$eventsSlider && this.$eventsSlider.length > 0)
      this.hasMobileSlider = true;

    if (this.hasMobileSlider) {
      this.mobile = $(window).width() < 992;
    }

    if (this.mobile) {
      this.firstChangeMobile = true;
    } else {
      this.firstChangeDesktop = true;
    }

    if (this.hasMobileSlider) {
      this.initMobileSlider();
    }

    this.initEventListeners();
  }

  initEventListeners() {
    $(document).on('click', '.events-item-info-types-more', (e) => {
      $(e.currentTarget)
        .parent('.events-item-info-types')
        .toggleClass('show-hidden');
    });

    $(document).on('click', '.events-item-card-mobile-types-toggle', (e) => {
      const $parent = $(e.currentTarget).parent(
        '.events-item-card-mobile-types'
      );
      if ($parent.is('.show-dropdown')) {
        $(document).unbind('click.mobileTypesToggle');
      } else {
        $(document).bind('click.mobileTypesToggle', (e) => {
          if (!$(e.target).closest('.events-item-card-mobile-types').length) {
            $parent.removeClass('show-dropdown');
            $(document).unbind('click.mobileTypesToggle');
          }
        });
      }
      $parent.toggleClass('show-dropdown');
    });
  }

  initMobileSlider() {
    this.slider = new Swiper('.events-slider', {
      navigation: {
        nextEl: '.events-slider-next',
        prevEl: '.events-slider-prev',
      },
      spaceBetween: 30,
      autoHeight: true,
    });
  }
}
